import { CameraControls, CameraControlsImpl } from '@react-three/drei';
import { useThree } from '@react-three/fiber';

import { useCameraControlsEvents } from 'app/modules/wallforming/components/scenes/camera-controls/hooks/useCameraControlsEvents';
import { LayerType } from 'app/modules/wallforming/components/scenes/camera-controls/types/layerType';

import type { RefObject } from 'react';

interface PreviewCameraControlsProps {
    previewCameraControlsRef: RefObject<CameraControls | null>;
}

export const PreviewCameraControls = ({ previewCameraControlsRef }: PreviewCameraControlsProps) => {
    const raycaster = useThree((state) => state.raycaster);

    const handlePreviewCameraControlsRef = (cameraControls: CameraControls | null) => {
        if (cameraControls) {
            cameraControls.camera.layers.enableAll();
            previewCameraControlsRef.current = cameraControls;

            if (raycaster) {
                raycaster.layers.disableAll();
                raycaster.layers.enable(LayerType.RAYCAST);
            }
        }
    };

    useCameraControlsEvents({ cameraControlsRef: previewCameraControlsRef, isMainCamera: false });

    return (
        <CameraControls
            ref={handlePreviewCameraControlsRef}
            dollySpeed={1.5}
            draggingSmoothTime={0.07}
            infinityDolly={true}
            mouseButtons={{
                left: CameraControlsImpl.ACTION.NONE,
                middle: CameraControlsImpl.ACTION.TRUCK,
                right: CameraControlsImpl.ACTION.NONE,
                wheel: CameraControlsImpl.ACTION.ZOOM
            }}
            truckSpeed={2}
            dollyToCursor
            makeDefault
        />
    );
};
